import { CaseConnectionParam } from 'app/infrastructure/ui/form/types';
import { ApplicationState } from 'app/types-store';
import { createSelector } from 'reselect';

export const getDraftId = (connectedDrafts: CaseConnectionParam[]) => {
  return (connectedDrafts?.length ?? 0) > 0
    ? connectedDrafts[0].draftId ?? undefined
    : undefined;
};

export const selectBowtieFavouriteId = (instanceKey: string) =>
  (state: ApplicationState): number => {
    return state.bowtie?.instances?.[instanceKey]?.bowtieFavouriteId;
};

export const selectConnectedCasesByConnectionType = (instanceKey: string, caseNumber: number) =>
  createSelector(
    (state: ApplicationState) => state.bowtie?.instances?.[instanceKey]?.connectedCasesByConnectionType,
    (connectedCasesByConnectionType) => connectedCasesByConnectionType?.[caseNumber] || {}
  );
